import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type Weight2IconProps = Partial<SVGIconProps>;

const Weight2Icon: FC<Weight2IconProps> = (props) => (
  <SVGIcon viewBox="0 0 19 20" {...props}>
    <path
      d="M7.9538 17.7189H11.0415C14.9012 17.7189 16.445 16.175 16.445 12.3154V7.68378C16.445 3.82413 14.9012 2.28027 11.0415 2.28027H7.9538C4.09415 2.28027 2.55029 3.82413 2.55029 7.68378V12.3154C2.55029 16.175 4.09415 17.7189 7.9538 17.7189Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.09091"
    />
    <path
      d="M13.5501 7.1357C11.242 5.08237 7.75289 5.08237 5.44482 7.1357L7.12763 9.83746C8.47851 8.63325 10.5164 8.63325 11.8673 9.83746L13.5501 7.1357Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.09091"
    />
  </SVGIcon>
);

export default Weight2Icon;
